document.querySelectorAll('[data-crwn-reviews-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('.crwn-reviews__grid');
  const dotsContainer = carousel.querySelector('[data-crwn-reviews-dots]');
  if (!track || !dotsContainer) return;

  const cards = Array.from(track.children);
  if (cards.length === 0) return;

  const goToLabelTemplate = dotsContainer.getAttribute('data-go-to-label') || '';
  let dots = [];

  const cardOffset = (card) => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;

  // Only render one dot per real scroll-snap stop, not one per card —
  // on wide screens where multiple cards are visible at once, the last
  // few cards never become "leading" and their dots would be dead.
  const snapStopIndices = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 1) return [0];
    const stops = [];
    cards.forEach((card, index) => {
      const offset = Math.min(cardOffset(card), maxScroll);
      if (!stops.some((stop) => Math.abs(stop.offset - offset) < 1)) {
        stops.push({ index, offset });
      }
    });
    return stops;
  };

  const buildDots = () => {
    const stops = snapStopIndices();
    dotsContainer.innerHTML = '';
    dots = stops.map((stop, position) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'crwn-reviews__dot';
      dot.dataset.cardIndex = String(stop.index);
      dot.setAttribute('aria-label', goToLabelTemplate.replace('__INDEX__', String(position + 1)));
      dot.addEventListener('click', () => {
        track.scrollTo({ left: Math.min(stop.offset, track.scrollWidth - track.clientWidth), behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
      return { el: dot, offset: stop.offset };
    });
    setActiveDot(0);
  };

  const setActiveDot = (position) => {
    dots.forEach((dot, i) => dot.el.classList.toggle('is-active', i === position));
  };

  const closestDotPosition = () => {
    let closest = 0;
    let closestDistance = Infinity;
    dots.forEach((dot, i) => {
      const distance = Math.abs(dot.offset - track.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = i;
      }
    });
    return closest;
  };

  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      setActiveDot(closestDotPosition());
      ticking = false;
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(buildDots, 150);
  });

  buildDots();
});
